let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kB6mR")).then(() => parcelRequire('hRQZD'));